
import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

interface StandardTextAreaFieldProps {
  id: string;
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  icon?: React.ReactNode;
}

const StandardTextAreaField: React.FC<StandardTextAreaFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  rows = 3,
  className,
  required = false,
  disabled = false,
  icon
}) => {
  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 dark:text-gray-200 flex items-center gap-2">
          {icon}
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Textarea
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={cn(
          "resize-none transition-all duration-200",
          className
        )}
        required={required}
        disabled={disabled}
      />
    </div>
  );
};

export default StandardTextAreaField;
